import { useState } from "react";
import Button from "../../../ui/Button";
import { FileIcon } from "../../../utils/icon.utils";
import CustomerAttachments from "./CustomerAttachments";
import { useQueryParams } from "../../../utils/queryParams.utils";
import CustomerMoneyReceipt from "./CustomerMoneyReceipt/CustomerMoneyReceipt";
import { arrayMap } from "../../../utils/array.utils";

export default function CustomerProfileNav({ data }) {
  const { searchParams, setSearchParams } = useQueryParams();

  const tab = searchParams.get("tab") ? Number(searchParams.get("tab")) : 2;

  const [activeTab, setActiveTab] = useState(tab);

  const onActiveTab = (id) => {
    setActiveTab(id);
    searchParams.set("tab", id);
    setSearchParams(searchParams);
  };

  const tabs = [
    {
      id: 2,
      name: "Money Receipt",
      icon: FileIcon,
      Component: CustomerMoneyReceipt
    },
    {
      id: 1,
      name: "Quotation",
      icon: FileIcon,
      Component: CustomerAttachments
    }
  ];

  const NoContent = () => {
    return "No Content";
  };

  const TabContent = tabs.find((item) => item.id === activeTab).Component ?? NoContent;

  return (
    <div>
      <ul className="list-unstyled d-flex flex-wrap gap-3 align-items-center">
        {arrayMap(tabs, (item) => (
          <li key={item.id}>
            <Button
              onClick={() => item.id !== activeTab && onActiveTab(item.id)}
              isActive={item.id === activeTab}
              name={item.name ?? ""}
              icon={item.icon ?? ""}
            />
          </li>
        ))}
      </ul>
      <TabContent data={data} />
    </div>
  );
}
